var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('card-total-s-o'),_c('card-total-incoming-s-o'),_c('card-total-s-o-need-approve'),_c('card-total-d-p-need-approve'),_c('card-total-kitting-need-approve')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }